/**
 * NB: Same enums are defined on Entity/EnforcementCase.php - Keep in sync!
 */
export enum CaseStatus {
  'OPEN' = 0,
  'CLOSED' = 1,
  'ARCHIVED' = 2,
  'STOPPED' = 3,
  'TARN' = 4,
  'REJECTED' = 5,
  'PARTIALLY_CLOSED' = 6,
  'BEING_REOPENED' = 10,
  'BEING_CLOSED' = 11,
  'BEING_PARTIALLY_CLOSED' = 12,
  'BEING_STOPPED' = 13,
  'BEING_UNSTOPPED' = 14,
}
